import React from "react";
import EpisodeCard from "../components/EpisodeCard";
import { episodeData } from "../components/episodeData";

const Episodes = () => {
  return (
    <div className="mt-10">
      <div className="flex justify-between">
        <h1 className="text-2xl text-dark-blue font-bold self-center">
          🟠 All Episodes
        </h1>
      </div>
      <div className="flex justify-between gap-4 flex-col md:flex-row md:flex-wrap">
        {episodeData.map((episode) => {
          const {
            serialNo,
            imageUrl,
            title,
            applePodcastUrl,
            googlePodcastUrl,
            spotifyPodcastUrl,
            anchorPodcastUrl,
          } = episode;
          return (
            <EpisodeCard
              serialNo={serialNo}
              imageUrl={imageUrl}
              title={title}
              applePodcastUrl={applePodcastUrl}
              googlePodcastUrl={googlePodcastUrl}
              spotifyPodcastUrl={spotifyPodcastUrl}
              anchorPodcastUrl={anchorPodcastUrl}
            />
          );
        })}
      </div>
    </div>
  );
};

export default Episodes;
